import { http } from "@/utils/http";
import { AxiosResponse } from "axios";
import { cleanParams } from "@/utils/cleanParams";
import { IDriverFilter } from "@/features/drivers/drivers.types";

export const driverService = {
  getDrivers(filter?: IDriverFilter): Promise<AxiosResponse> {
    return http.get("/drivers", {
      params: cleanParams(filter),
    });
  },

  getSimpleDrivers(filter?: IDriverFilter): Promise<AxiosResponse> {
    return http.get("/drivers/simple", {
      params: cleanParams(filter),
    });
  },

  addDriverNote(
    driverId: string,
    payload: { note: string }
  ): Promise<AxiosResponse> {
    return http.put(`/drivers/${driverId}/note`, payload);
  },
};
